import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const subjectService = {
  /**
   * =========================================================
   * ✅ MY SUBJECTS
   * =========================================================
   */

  async getMySubjects() {
    const res = await axios.get(SERVER_URL + "bsz/subjects/me", {
      headers: authHeader(),
    });

    return res.data;
  },

  async saveMySubjects(subjectIds) {
    const res = await axios.post(
      SERVER_URL + "bsz/subjects/me",
      { subjectIds },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ ALL SUBJECTS
   * =========================================================
   */

  async getSubjects() {
    const res = await axios.get(SERVER_URL + "bsz/subjects", {
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ ADMIN SUBJECT MANAGEMENT
   * =========================================================
   */

  async saveSubjects(subjects) {
    const res = await axios.post(
      SERVER_URL + "bsz/admin/subjects",
      { subjects },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },
};

export default subjectService;
